// src/main.ts
import { createApp, App as VueApp } from 'vue';
import App from './App.vue';
import router from './router';
import { auth } from './firebaseConfig';
// Optionally import and initialize Firebase Functions if you plan to call callable functions
import { getFunctions } from 'firebase/functions';

let app: VueApp<Element> | undefined;

// Initialize Firebase Functions (not needed for Firestore-triggered functions)
const functions = getFunctions();

auth.onAuthStateChanged((user) => {
  console.log("Auth state changed in production:", user);
  if (!app) {
    app = createApp(App);
    app.use(router);
    app.mount('#app');
  }
});
